
function moveTaskReviewDialog () {
  return {
    restrict: 'E',
    templateUrl: '/workflow/dialogs/move-task-review/move-task-review-dialog.html?$$REVISION$$'
  }
}

export { moveTaskReviewDialog }
